import React from 'react'
import CommWhatsAppCompose from './CommWhatsAppCompose'

// Created By Cursor
const CommComposeGeneric = (props) => <CommWhatsAppCompose {...props} />

export default CommComposeGeneric
